module.exports = __webpack_public_path__ + "media/images/catalogs/items/options/icons/ironing-1cae9a661125460a5a26563632960e2e.svg";